var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { components, createFilter } from 'react-select';
import { Icon, TYPOGRAPHY } from '../../../../index';
import { addCustomProps } from '../../../../components/ui-foundations/dropdowns/utils';
import { StyledCreateableSelect } from './CreateableSelect.styles';
const DropdownIndicator = (indicatorProps) => {
    return (React.createElement(components.DropdownIndicator, Object.assign({}, indicatorProps),
        React.createElement(Icon, { name: "fa-caret-down", ariaLabel: "open dropdown", size: [TYPOGRAPHY.fontSize.base] })));
};
const CustomOption = (optionProps) => {
    const { children, data } = optionProps, rest = __rest(optionProps, ["children", "data"]);
    const iconString = (data === null || data === void 0 ? void 0 : data.icon) || '';
    const swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || '';
    return (React.createElement(components.Option, Object.assign({}, rest),
        swatchColor ? (React.createElement("span", { className: "swatch", style: { backgroundColor: swatchColor } })) : null,
        iconString ? (React.createElement(Icon, { name: iconString, className: "inline-icon", ariaLabel: `${iconString} icon`, size: [TYPOGRAPHY.fontSize.base] })) : null,
        children));
};
const CustomSingleValue = (optionProps) => {
    const { children, data } = optionProps, rest = __rest(optionProps, ["children", "data"]);
    const iconString = (data === null || data === void 0 ? void 0 : data.icon) || '';
    const swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || '';
    return (React.createElement(components.SingleValue, Object.assign({}, rest),
        swatchColor ? (React.createElement("span", { className: "swatch", style: { backgroundColor: swatchColor } })) : null,
        iconString ? (React.createElement(Icon, { name: iconString, className: "inline-icon", ariaLabel: `${iconString} icon`, size: [TYPOGRAPHY.fontSize.base] })) : null,
        children));
};
export const CreateableSelect = React.forwardRef((props, ref) => {
    const { id, isDisabled, className, isClearable, closeMenuOnSelect, isLoading, onChange, dropdownIndicatorProps = {}, onCreateOption, placeholder, value, menuIsOpen, options, hasWordBreak = true, defaultValue, labelText, hasHiddenLabel = false, } = props;
    const [localOptions, setLocalOptions] = useState(options);
    const [localValue, setLocalValue] = useState(value);
    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: 'start',
    };
    const handleCreate = (inputValue) => {
        const newOption = createOption(inputValue);
        setLocalOptions((prev) => [...prev, newOption]);
        setLocalValue(newOption);
        onCreateOption(inputValue);
    };
    const createOption = (label) => ({
        label,
        value: label.toLowerCase(),
    });
    const handleSelectChange = (newValue) => {
        setLocalValue(newValue);
        onChange(newValue);
    };
    const breakWord = hasWordBreak ? 'has-word-break' : '';
    return (React.createElement("div", { className: 'combobox-container' },
        React.createElement("label", { "data-testid": "combobox-label", className: hasHiddenLabel ? 'aria-invisible' : '', htmlFor: id }, labelText),
        React.createElement(StyledCreateableSelect, { id: id, ref: ref, components: {
                DropdownIndicator: addCustomProps(DropdownIndicator, dropdownIndicatorProps),
                Option: CustomOption,
                SingleValue: CustomSingleValue,
            }, isDisabled: isLoading || isDisabled, isLoading: isLoading, closeMenuOnSelect: closeMenuOnSelect, menuIsOpen: menuIsOpen, isClearable: isClearable, hasWordBreak: hasWordBreak, options: localOptions, classNamePrefix: 'combobox', className: `${breakWord} ${className}`, placeholder: placeholder, onChange: handleSelectChange, onCreateOption: handleCreate, value: localValue, defaultValue: defaultValue, filterOption: createFilter(filterConfig) })));
});
//# sourceMappingURL=CreateableSelect.js.map